import { Route } from '@angular/router';
import { RenderEngineComponent } from '@app/pages/render-engine/render-engine.component';

export const FAQS_ROUTES: Route[] = [
  {
    path: '',
    component: RenderEngineComponent,
  },
  {
    path: ':category/:subcategory',
    component: RenderEngineComponent,
  },
  {
    path: ':category',
    component: RenderEngineComponent,
  },
];
